export const SHIFT_OFFERS_ASSIGNMENT_STRATEGY = {
  FIRST_COME_FIRST_SERVE: 'FIRST_COME_FIRST_SERVE',
  MANUAL: 'MANUAL',
};

export const SHIFT_OFFERS_PUBLISH_STRATEGY = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
};
